// extracted by mini-css-extract-plugin
export default {"caseContainer":"case_caseContainer__0j1Kh"};